
import { IbisPreparedStatement } from './ibis-prepared-statements';
import { IbisReport } from './ibis-report';

export interface ibisList{
    items: IbisReport[],
    totalItems: number
}

export interface ibisResponse{
    result: ibisList
    success: boolean
}

export interface removeResponse{
    success: boolean
}
export interface IbisBlurbResponse{
  result: IbisPreparedStatement
  success: boolean
}

export class ibisQueryParam{
    query: string;
    order: string;
    field: string;
    page: number;

    constructor(){
      this.query = '';
      this.order = '';
      this.field = '';
      this.page = 1;
    }
}

